//====================================================
//  Function: Select
//====================================================
function fn_components_select(){
	if ($('.js-select').length){
		$('.js-select').select2({
			minimumResultsForSearch: Infinity,
			placeholder: function(){
				$(this).data('placeholder');
			}
		}).focus(function () { $(this).select2('open'); });
	}



	if ($('.js-select-object').length){
		$(".js-select-object").select2({
			minimumResultsForSearch: Infinity,
			templateResult: status,
			placeholder: function(){
				$(this).data('placeholder');
			}
		}).focus(function () { $(this).select2('open'); });
	}

	function status (state) {
		if (!state.id) { return state.text; }
		var $state = $(
			'<span class="text-option"><span class="status status-' + state.title + '"></span><span class="text">' + state.text + '</span></span>'
		);
		return $state;
	};


}